<div class="d-flex flex-row mt-1 justify-content-center">
    @if (customActionButtons().length > 0) {
        @for (custom of customActionButtons(); track custom) {
            @if (
                (!custom.hasOwnProperty("onlyIf") || (custom.onlyIf && custom.onlyIf(data()))) &&
                (!isMobile || (isMobile && custom.showOnMobile === true))
            ) {
                <span
                    class="custom-action"
                    [class]="
                        actionRules(actionsEvents.custom, 'isDisabled', custom) ? custom.iconName + ' pointer' : custom.disableIconName + ' disabled'
                    "
                    [title]="
                        actionRules(actionsEvents.custom, 'isDisabled', custom)
                            ? (custom.iconTitle | translate)
                            : (custom.iconDisabledTitle! | translate)
                    "
                    [id]="'listAction' + custom.eventName"
                    (click)="actionRules(actionsEvents.custom, 'isDisabled', custom) && customClicked.emit(custom.eventName)"
                ></span>
            }
        }
    }
    @if (!isMobile && enableConnectionsAction() && actionRules(actionsEvents.connections, "isHidden")) {
        <span
            [class]="actionRules(actionsEvents.connections) ? 'adaa-icon-connections pointer' : 'adaa-icon-connections disabled'"
            [title]="actionRules(actionsEvents.connections) ? ('tooltips.connections' | translate) : ('tooltips.connections_disabled' | translate)"
            id="listActionConnections"
            (click)="actionRules(actionsEvents.connections) && actionClicked.emit(actionsEvents.connections)"
        ></span>
    }
    @if (enableViewAction() && actionRules(actionsEvents.view, "isHidden")) {
        <span
            [class]="actionRules(actionsEvents.view) ? 'adaa-icon-view1 pointer' : 'adaa-icon-view disabled'"
            [title]="actionRules(actionsEvents.view) ? ('tooltips.view' | translate) : ('tooltips.view_disabled' | translate)"
            *adaaHasPermission="viewPermission()"
            id="listActionAdd"
            (click)="actionRules(actionsEvents.view) && actionClicked.emit(actionsEvents.view)"
        ></span>
    }
    @if (!isMobile && enableEditAction() && actionRules(actionsEvents.edit, "isHidden")) {
        <span
            [class]="actionRules(actionsEvents.edit) ? 'adaa-icon-edit pointer' : 'adaa-icon-edit disabled'"
            [title]="actionRules(actionsEvents.edit) ? ('tooltips.edit' | translate) : ('tooltips.edit_disabled' | translate)"
            *adaaHasPermission="managePermission()"
            id="listActionEdit"
            (click)="actionRules(actionsEvents.edit) && actionClicked.emit(actionsEvents.edit)"
        ></span>
    }
    @if (!isMobile && enableDeleteAction() && actionRules(actionsEvents.delete, "isHidden")) {
        <span
            [class]="actionRules(actionsEvents.delete) ? 'adaa-icon-delete pointer' : 'adaa-icon-delete disabled'"
            [title]="actionRules(actionsEvents.delete) ? ('tooltips.delete' | translate) : ('tooltips.delete_disabled' | translate)"
            *adaaHasPermission="managePermission()"
            id="listActionDelete"
            (click)="actionRules(actionsEvents.delete) && actionClicked.emit(actionsEvents.delete)"
        ></span>
    }
</div>
